var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHproduceUnited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 172,
    viewBox: "0 0 240 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3161_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M71.3042 7.09858C47.8923 14.6466 8.27162 27.0705 1.79749 59.2805C-3.04635 83.3937 -0.804707 146.369 43.3385 161.755C102.719 182.47 205.129 172.379 227.279 125.921C241.505 96.1002 245.306 35.9504 201.751 17.9564C172.241 5.76658 121.585 -9.06298 71.3042 7.09858Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05 41.3833H113.833V77.1777H118.05V41.3833Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.036 35.2206L176.251 63.7725L180.027 65.7063L193.812 37.1545L190.036 35.2206Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.739 106.869L128.062 110.225L163.027 139.806L165.704 136.45L130.739 106.869Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.601 139.12C167.786 138.83 167.892 138.494 167.907 138.147C167.922 137.8 167.846 137.456 167.687 137.15L163.917 139.087C162.945 137.085 164.701 135.705 168.871 132.363C171.308 130.425 174.741 127.81 179.06 124.597C186.42 119.132 193.952 113.755 194.023 113.699L196.429 117.267C185.33 125.21 169.043 137.239 167.601 139.12Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.224 92.5241L131.742 88.4555L176.278 71.1799L228.016 68.4998L228.235 72.8429L177.148 75.4907L133.224 92.5241Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8889 111.422L61.8607 132.786L64.1034 136.464L97.1316 115.1L94.8889 111.422Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7635 64.8246L73.6048 67.7019L94.4269 91.9505L97.5856 89.0732L76.7635 64.8246Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0599 98.1829L18.0142 94.3807L57.972 71.5753L14.8869 37.9444L17.4342 34.4812L65.6845 72.1404L20.0599 98.1829Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3219 49.0767H49.3424C46.0092 49.0767 43.3072 51.8596 43.3072 55.2926V81.0204C43.3072 84.4533 46.0092 87.2363 49.3424 87.2363H74.3219C77.655 87.2363 80.3571 84.4533 80.3571 81.0204V55.2926C80.3571 51.8596 77.655 49.0767 74.3219 49.0767Z",
    fill: "#40A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.202 56.1968H164.223C160.89 56.1968 158.188 58.9798 158.188 62.4128V88.1405C158.188 91.5735 160.89 94.3565 164.223 94.3565H189.202C192.536 94.3565 195.238 91.5735 195.238 88.1405V62.4128C195.238 58.9798 192.536 56.1968 189.202 56.1968Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.202 56.1968H164.223C160.89 56.1968 158.188 58.9798 158.188 62.4128V88.1405C158.188 91.5735 160.89 94.3565 164.223 94.3565H189.202C192.536 94.3565 195.238 91.5735 195.238 88.1405V62.4128C195.238 58.9798 192.536 56.1968 189.202 56.1968Z",
    fill: "#009D93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.361 68.4165H167.375C166.247 68.4165 165.333 67.5024 165.333 66.3749C165.333 65.2473 166.247 64.3333 167.375 64.3333H182.361C183.488 64.3333 184.402 65.2473 184.402 66.3749C184.402 67.5024 183.488 68.4165 182.361 68.4165Z",
    fill: "url(#paint0_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.877 74.5232H170.891C170.162 74.5232 169.488 74.1341 169.123 73.5024C168.758 72.8707 168.758 72.0924 169.123 71.4608C169.488 70.8291 170.162 70.4399 170.891 70.4399H185.877C187.004 70.4399 187.918 71.354 187.918 72.4816C187.918 73.6091 187.004 74.5232 185.877 74.5232Z",
    fill: "url(#paint1_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.361 80.8931H167.375C166.247 80.8931 165.333 79.979 165.333 78.8514C165.333 77.7239 166.247 76.8098 167.375 76.8098H182.361C183.488 76.8098 184.402 77.7239 184.402 78.8514C184.402 79.979 183.488 80.8931 182.361 80.8931Z",
    fill: "url(#paint2_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.877 87H170.891C169.764 87 168.849 86.0859 168.849 84.9584C168.849 83.8308 169.764 82.9167 170.891 82.9167H185.877C187.004 82.9167 187.918 83.8308 187.918 84.9584C187.918 86.0859 187.004 87 185.877 87Z",
    fill: "url(#paint3_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1488 113.271H44.1693C40.8362 113.271 38.1341 116.054 38.1341 119.487V145.214C38.1341 148.647 40.8362 151.43 44.1693 151.43H69.1488C72.482 151.43 75.184 148.647 75.184 145.214V119.487C75.184 116.054 72.482 113.271 69.1488 113.271Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.1488 113.271H44.1693C40.8362 113.271 38.1341 116.054 38.1341 119.487V145.214C38.1341 148.647 40.8362 151.43 44.1693 151.43H69.1488C72.482 151.43 75.184 148.647 75.184 145.214V119.487C75.184 116.054 72.482 113.271 69.1488 113.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.977 124.104H156.628C154.182 124.104 152.2 126.147 152.2 128.666V147.564C152.2 150.083 154.182 152.125 156.628 152.125H174.977C177.422 152.125 179.405 150.083 179.405 147.564V128.666C179.405 126.147 177.422 124.104 174.977 124.104Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.043 138.332C168.043 139.459 167.129 140.373 166.001 140.373C164.873 140.373 163.959 139.459 163.959 138.332C163.959 137.204 164.873 136.29 166.001 136.29C167.129 136.29 168.043 137.204 168.043 138.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.095 129C167.346 128.999 167.565 129.171 167.625 129.415L168.152 131.555C168.555 131.683 168.945 131.847 169.319 132.045L170.983 131.048C171.199 130.918 171.475 130.952 171.652 131.13L173.198 132.677C173.376 132.854 173.411 133.13 173.281 133.345L172.283 135.006C172.483 135.382 172.649 135.775 172.777 136.182L174.919 136.708C175.163 136.768 175.334 136.987 175.333 137.238V139.425C175.334 139.676 175.163 139.896 174.919 139.956L172.777 140.482C172.653 140.878 172.494 141.263 172.302 141.631L173.285 143.269C173.415 143.484 173.381 143.76 173.203 143.937L171.654 145.486C171.477 145.664 171.201 145.699 170.986 145.569L170.059 145.013L169.956 144.951C169.74 144.821 169.527 144.694 169.365 144.597C168.978 144.806 168.571 144.979 168.151 145.112L167.625 147.252C167.565 147.496 167.346 147.667 167.095 147.667H164.907C164.656 147.667 164.437 147.496 164.377 147.252L163.851 145.112C163.441 144.982 163.044 144.815 162.664 144.613L162.006 145.007L161.938 145.048L161.637 145.228L161.575 145.265L161.069 145.564C160.855 145.695 160.579 145.663 160.4 145.486L158.853 143.937C158.676 143.759 158.644 143.483 158.776 143.269L159.726 141.676C159.522 141.293 159.353 140.893 159.223 140.48L157.081 139.953C156.838 139.893 156.667 139.676 156.667 139.425V137.238C156.666 136.987 156.837 136.768 157.081 136.708L159.223 136.18C159.338 135.818 159.482 135.465 159.654 135.126L158.586 133.345C158.456 133.13 158.491 132.854 158.669 132.677L160.215 131.13C160.393 130.953 160.668 130.919 160.884 131.048L162.61 132.083C163.006 131.867 163.423 131.69 163.854 131.555C163.905 131.339 163.979 131.03 164.057 130.711L164.077 130.628C164.226 130.02 164.375 129.413 164.375 129.413C164.435 129.169 164.656 128.998 164.907 129H167.095ZM166.001 133.374C163.262 133.374 161.042 135.594 161.042 138.332C161.042 141.07 163.262 143.289 166.001 143.289C168.74 143.289 170.96 141.07 170.96 138.332C170.96 137.017 170.438 135.756 169.508 134.826C168.578 133.897 167.316 133.374 166.001 133.374Z",
    fill: "url(#paint4_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.176 17.5286H103.714C100.454 17.5286 97.8121 20.2501 97.8121 23.6073V48.8022C97.8121 52.1594 100.454 54.881 103.714 54.881H128.176C131.436 54.881 134.078 52.1594 134.078 48.8022V23.6073C134.078 20.2501 131.436 17.5286 128.176 17.5286Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M128.176 17.5286H103.714C100.454 17.5286 97.8121 20.2501 97.8121 23.6073V48.8022C97.8121 52.1594 100.454 54.881 103.714 54.881H128.176C131.436 54.881 134.078 52.1594 134.078 48.8022V23.6073C134.078 20.2501 131.436 17.5286 128.176 17.5286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5007 23.5588H8.19325C6.1544 23.5588 4.50159 25.2612 4.50159 27.3611V43.1271C4.50159 45.227 6.1544 46.9293 8.19325 46.9293H23.5007C25.5396 46.9293 27.1924 45.227 27.1924 43.1271V27.3611C27.1924 25.2612 25.5396 23.5588 23.5007 23.5588Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M23.5007 23.5588H8.19325C6.1544 23.5588 4.50159 25.2612 4.50159 27.3611V43.1271C4.50159 45.227 6.1544 46.9293 8.19325 46.9293H23.5007C25.5396 46.9293 27.1924 45.227 27.1924 43.1271V27.3611C27.1924 25.2612 25.5396 23.5588 23.5007 23.5588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1904 88.3989H13.8757C12.4992 88.3989 11.3833 89.5483 11.3833 90.966V101.59C11.3833 103.008 12.4992 104.157 13.8757 104.157H24.1904C25.567 104.157 26.6829 103.008 26.6829 101.59V90.966C26.6829 89.5483 25.567 88.3989 24.1904 88.3989Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M24.1904 88.3989H13.8757C12.4992 88.3989 11.3833 89.5483 11.3833 90.966V101.59C11.3833 103.008 12.4992 104.157 13.8757 104.157H24.1904C25.567 104.157 26.6829 103.008 26.6829 101.59V90.966C26.6829 89.5483 25.567 88.3989 24.1904 88.3989Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.702 105.392H188.387C187.011 105.392 185.895 106.541 185.895 107.959V118.583C185.895 120 187.011 121.15 188.387 121.15H198.702C200.078 121.15 201.194 120 201.194 118.583V107.959C201.194 106.541 200.078 105.392 198.702 105.392Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M198.702 105.392H188.387C187.011 105.392 185.895 106.541 185.895 107.959V118.583C185.895 120 187.011 121.15 188.387 121.15H198.702C200.078 121.15 201.194 120 201.194 118.583V107.959C201.194 106.541 200.078 105.392 198.702 105.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.469 28.3298H184.155C182.778 28.3298 181.662 29.4792 181.662 30.897V41.5206C181.662 42.9384 182.778 44.0878 184.155 44.0878H194.469C195.846 44.0878 196.962 42.9384 196.962 41.5206V30.897C196.962 29.4792 195.846 28.3298 194.469 28.3298Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M194.469 28.3298H184.155C182.778 28.3298 181.662 29.4792 181.662 30.897V41.5206C181.662 42.9384 182.778 44.0878 184.155 44.0878H194.469C195.846 44.0878 196.962 42.9384 196.962 41.5206V30.897C196.962 29.4792 195.846 28.3298 194.469 28.3298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.744 55.4944H218.132C215.782 55.4944 213.876 57.4569 213.876 59.8779V78.0172C213.876 80.4382 215.782 82.4007 218.132 82.4007H235.744C238.094 82.4007 240 80.4382 240 78.0172V59.8779C240 57.4569 238.094 55.4944 235.744 55.4944Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3668 17.9968H65.6844V36.2088H83.3668V17.9968Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.704 31.8335H152.544V41.9002H165.704V31.8335Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3157 78.9998C52.787 78.9999 52.2799 78.79 51.9059 78.4164C48.0925 74.6052 46.9516 68.8733 49.0152 63.8935C51.0788 58.9137 55.9406 55.6667 61.3333 55.6667C66.7261 55.6667 71.5879 58.9137 73.6515 63.8935C75.7151 68.8733 74.5742 74.6052 70.7608 78.4164C69.9821 79.1946 68.7197 79.1946 67.9411 78.4164C67.1625 77.6382 67.1625 76.3764 67.9411 75.5982C70.6138 72.9269 71.4133 68.9095 69.9669 65.4193C68.5205 61.9291 65.113 59.6534 61.3333 59.6534C57.5537 59.6534 54.1461 61.9291 52.6997 65.4193C51.2533 68.9095 52.0529 72.9269 54.7256 75.5982C55.2959 76.168 55.4665 77.0252 55.1579 77.7698C54.8493 78.5145 54.1222 78.9999 53.3157 78.9998Z",
    fill: "url(#paint5_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.376 70.1366C60.57 70.1364 59.8435 69.6511 59.535 68.9069C59.2265 68.1628 59.3966 67.3061 59.9661 66.7362L66.8469 59.8556C67.6274 59.0884 68.8807 59.0938 69.6546 59.8675C70.4284 60.6413 70.4333 61.894 69.6655 62.6738L62.7825 69.5533C62.4098 69.9268 61.9037 70.1367 61.376 70.1366Z",
    fill: "url(#paint6_linear_3161_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 125.667H109.172C96.8689 125.667 88.6667 117.464 88.6667 105.161V72.3333H121.476C133.779 72.3333 141.981 80.5355 141.981 92.8388V125.667H142Z",
    fill: "#004E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.374 90.7883H121.476C129.132 90.7883 133.779 95.4538 133.779 103.092V117.446H129.678C122.134 117.446 117.374 112.63 117.374 105.142V90.7883Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8689 80.5359H113.273V117.446H109.172C101.553 117.446 96.8689 112.837 96.8689 105.143V80.5359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3161_1279",
    x1: 165.333,
    y1: 68.4165,
    x2: 184.402,
    y2: 68.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3161_1279",
    x1: 168.849,
    y1: 74.5232,
    x2: 187.918,
    y2: 74.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3161_1279",
    x1: 165.333,
    y1: 80.8931,
    x2: 184.402,
    y2: 80.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3161_1279",
    x1: 168.849,
    y1: 87,
    x2: 187.918,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3161_1279",
    x1: 158.442,
    y1: 129,
    x2: 158.442,
    y2: 144.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3161_1279",
    x1: 49.8735,
    y1: 55.6747,
    x2: 49.8735,
    y2: 75.7343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3161_1279",
    x1: 64.3204,
    y1: 58.1549,
    x2: 56.1447,
    y2: 65.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3161_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHproduceUnited);
export default __webpack_public_path__ + "static/media/hproduce-united.dde3f0a528884bec8207c4b101e79369.svg";
export { ForwardRef as ReactComponent };